import { defineComponent as k, inject as s, createElementBlock as y, openBlock as b, mergeProps as d, unref as i, createVNode as f, createSlots as A, withCtx as B } from "vue";
import m from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Menu/menu.js";
import C from "../Button.vue2.js";
import { MenuInjectionKey as M } from "./Menu.vue2.js";
import { MenuItemInjectionKey as P } from "./MenuItem.vue2.js";
import { StarIcon as S } from "../../packages/icons/dist/esm/icons/star-icon.js";
import { isDefined as c } from "../../node_modules/.pnpm/@vueuse_shared@13.1.0_vue@3.5.13_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
import { useOUIAProps as h } from "../../helpers/ouia.js";
const N = /* @__PURE__ */ k({
  name: "PfMenuItemAction",
  inheritAttrs: !1,
  __name: "MenuItemAction",
  props: {
    icon: {},
    favorited: { type: Boolean, default: void 0 },
    disabled: { type: Boolean },
    actionId: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  emits: ["click"],
  setup(l, { emit: p }) {
    const n = l, u = h({ id: n.ouiaId, safe: n.ouiaSafe }), I = p, t = s(M), e = s(P);
    function v(o) {
      var a;
      I("click", o), e != null && e.itemId.value && ((a = t == null ? void 0 : t.onActionClick) == null || a.call(t, o, e == null ? void 0 : e.itemId.value, n.actionId));
    }
    return (o, a) => {
      var r;
      return b(), y("div", d(i(u), {
        class: [i(m).menuItemAction, {
          "pf-m-favorite": i(c)(o.favorited),
          [i(m).modifiers.favorited]: o.favorited
        }]
      }), [
        f(C, d(o.$attrs, {
          role: "menuitem",
          variant: "plain",
          disabled: o.disabled || ((r = i(e)) == null ? void 0 : r.disabled) || void 0,
          tabindex: -1,
          onClick: v
        }), A({ _: 2 }, [
          o.icon === "favorites" || i(c)(o.favorited) ? {
            name: "icon",
            fn: B(() => [
              f(i(S))
            ]),
            key: "0"
          } : void 0
        ]), 1040, ["disabled"])
      ], 16);
    };
  }
});
export {
  N as default
};
